import * as Actions from '../actions/actionTypes';

const initialState = {
    isFetching : false,
    err : false,
    isFetched : false,
    message : ''
  };

  // receiving response sent by action according to type of action
  export default function updatePostCategoryReducer(state = initialState, action) {
    //console.log(action,'action')
  switch (action.type) {
    case Actions.UPDATEPOSTCATEGORYREQUEST:
      return { 
          isFetching : true,
          err : false,
          isFetched : false,
          message : 'fetching...'
      };
      break;

    case Actions.UPDATEPOSTCATEGORYSUCCESS:
      return { 
          isFetching : false,
          err : false,
          isFetched : true,
          message : action.payload.message
          
        };
        break;
        
        case Actions.UPDATEPOSTCATEGORYERROR:
        return { 
          isFetching : false,
          err : true,
          isFetched : false,
          message : action.payload.message
       };
      break;
    
    default:
      return state;
  }
}  